import React from "react";

function formatDuration(seconds) {
  if (!seconds || seconds <= 0) return null;
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  const pad = (num) => String(num).padStart(2, "0");
  if (h > 0) {
    return `${h}:${pad(m)}:${pad(s)}`;
  }
  return `${m}:${pad(s)}`;
}

const VideoCard = ({ video }) => {
  const durationText = formatDuration(video.duration);

  return (
    <div className="group glass-card rounded-2xl p-3 cursor-pointer w-full transition-all duration-300">
      <div className="mb-3 relative overflow-hidden rounded-xl bg-slate-900">
        <img
          src={video.imgUrl}
          alt={video.title}
          className="object-cover w-full aspect-video rounded-xl bg-slate-900 group-hover:scale-105 transition-transform duration-300 ease-out"
        />
        {durationText && (
          <span className="absolute bottom-2 right-2 bg-black/80 backdrop-blur-md border border-white/10 text-slate-100 text-[11px] font-semibold px-2 py-0.5 rounded-md tracking-wider">
            {durationText}
          </span>
        )}
      </div>
      <div className="flex gap-3 w-full items-start px-0.5">
        <img
          className="rounded-full h-9 w-9 border border-blue-500/30 object-cover shrink-0 mt-0.5"
          src={video.user?.imgUrl || video.user?.profileImageUrl}
          alt={video.user?.name || "Uploader"}
        />
        <div className="flex flex-col min-w-0 flex-1">
          <h3 className="text-sm text-slate-100 font-semibold truncate leading-tight group-hover:text-cyan-400 transition-colors">
            {video.title}
          </h3>
          <span className="text-xs text-slate-400 font-medium truncate mt-1">
            {video.user?.name || "Unknown Creator"}
          </span>
          <div className="flex items-center gap-1 text-[11px] text-slate-400 mt-0.5">
            <span>{video.views || 0} views</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoCard;
